export default function onBlur() {
  if (this.codeView.isActive()) {
    this.codeView.toggle();
    this.codeView.toggle();
  }
}
